import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

// This section is copied from the ASTM C136 worksheet
let PortionSievingDetailsSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isWashed = useSelector(pipe(createWorksheetSelector!('Washing.IsWashed'), valueOrDefault(false)));

  const wholePortionPath = namePrefix?.substr(0, namePrefix.lastIndexOf('.WholePortion') + '.WholePortion'.length);

  const isWholePortionWashed = useSelector(
    pipe(createWorksheetSelector!(`${wholePortionPath}.Washing.IsWashed`, false), valueOrDefault(false))
  );

  const isCoarseSievingRepresentingWholePortion = namePrefix?.endsWith('WholePortion.Separation.CoarsePortion');

  const isCoarseSievingRepresentingSeparatedPortion = namePrefix?.endsWith(
    'FinePortion.Subspecimen.Separation.CoarsePortion'
  );

  const coarsePortionParentPath = namePrefix?.substr(0, namePrefix.lastIndexOf('.Separation.CoarsePortion'));

  const isCoarsePortionParentWashed = useSelector(
    pipe(createWorksheetSelector!(`${coarsePortionParentPath}.Washing.IsWashed`, false), valueOrDefault(false))
  );

  const isWholePortionSieving = namePrefix?.endsWith('WholePortion');

  const isWholePortionWetBeforeSieving = useSelector(
    pipe(
      createWorksheetSelector!(
        `${namePrefix!.substring(
          0,
          namePrefix!.indexOf('.WholePortion') + '.WholePortion'.length
        )}.Masses.StateAfterMassDetermination`,
        false
      ),
      (s: StateOfMaterial) => s !== StateOfMaterial.OvenDry
    )
  );

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      {(isCoarseSievingRepresentingWholePortion || isWholePortionSieving) && (
        <NamePrefixModifier namePrefix={wholePortionPath}>
          <Field
            input={<TextOutput />}
            label="Specimen Total Wet Mass"
            name="Masses.WetMass"
            visible={isWholePortionWetBeforeSieving}
          />
          <Field input={<TextOutput />} label="Specimen Total Dry Mass" name="Masses.DryMass" />
          <Field input={<TextOutput />} name="Washing.WashedDryMass" visible={isWholePortionWashed} />
        </NamePrefixModifier>
      )}
      {isCoarseSievingRepresentingSeparatedPortion && (
        <NamePrefixModifier namePrefix={coarsePortionParentPath}>
          <Field input={<TextOutput />} label="Subspecimen Total Dry Mass" name="Masses.DryMass" />

          <Field
            input={<TextOutput />}
            label="Subspecimen Washed Dry Mass"
            name="Washing.WashedDryMass"
            visible={isCoarsePortionParentWashed}
          />
        </NamePrefixModifier>
      )}
      {!isWholePortionSieving && (
        <>
          <Field input={<TextOutput />} label="Sieve Portion Material Dry Mass" name="Masses.DryMass" />
          <Field
            input={<TextOutput />}
            label="Sieve Portion Washed Material Dry Mass"
            name="Washing.WashedDryMass"
            visible={isWashed}
          />
        </>
      )}
      {!(isCoarseSievingRepresentingWholePortion || isWholePortionSieving) && (
        <Field input={<TextOutput />} label="Mass Upscale Factor" name="Masses.MassUpscaleFactor" />
      )}
    </ListFieldSection>
  );
};
PortionSievingDetailsSection = withInjectedProps(PortionSievingDetailsSection);

export { PortionSievingDetailsSection };
export default PortionSievingDetailsSection;
